import ReportPage from './ReportPage'

export default function CadastroLojistasReport({className = ''}: {className?: string}) {
  return <ReportPage type='cadastro_lojistas' className={className} />
}
